import { Controller } from "@hotwired/stimulus"
import { showToast } from "../helpers/toast"

export default class extends Controller {
  static values = { title: String, url: String }

  async share() {
    if (navigator.share) {
      try {
        await navigator.share({ title: this.titleValue, url: this.urlValue })
      } catch { /* user cancelled */ }
    } else {
      await navigator.clipboard.writeText(this.urlValue)
      showToast("Link copied to clipboard!")
    }
  }
}
